import styled from "styled-components";

export const Wrapper = styled.div`
  height: 50px;
  border-radius: 2px;
  display: inline-block;
  margin-top: 1rem;
  padding: 2px;
  transition: var(--transition);
  animation: animate 20s linear infinite;
  background-size: 1000%;
  @keyframes animate {
    0% {
      background-position: 0% 100%;
    }
    5% {
      background-position: 100% 0%;
    }
    100% {
      background-position: 0% 100%;
    }
  }

  @media screen and (max-width: 992px) {
    text-align: center;
  }
`;
export const Link = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  background-color: var(--background-color);
  color: var(--text-color);
  text-transform: uppercase;
  border-radius: 2px;
  padding: 0 1rem;
  .download-icon {
    transition: var(--transition);
  }

  &:hover .download-icon {
    transform: rotateX(180deg);
  }
`;
